import { render, staticRenderFns } from "./scope128.vue?vue&type=template&id=6b44a48d&scoped=true"
import script from "./scope128.vue?vue&type=script&lang=js"
export * from "./scope128.vue?vue&type=script&lang=js"
import style0 from "./scope128.vue?vue&type=style&index=0&id=6b44a48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44a48d",
  null
  
)

export default component.exports